import React from 'react'
import {
  HOST,
  IS_LOCAL,
  DEBUG_MODE,
  IS_PRODUCTION,
  ARWEAVE_GATEWAY,
  ARWEAVE_GATEWAY_MAIN,
  CURRENCY_SYMBOL_EURO,
  CURRENCY_SYMBOL_US_DOLLAR,
  ISO_4217_CURRENCY_CODE_EURO,
  PRACTICAL_STREAM_CDN_ADDRESS,
  CURRENCY_SYMBOL_CANADA_DOLLAR,
  CURRENCY_SYMBOL_BRITISH_POUND,
  DEFAULT_SUBSCRIPTION_PRICE_USD,
  PRACTICAL_STREAM_INDEXED_DB_NAME,
  ISO_4217_CURRENCY_CODE_US_DOLLAR,
  PRACTICAL_STREAM_INDEXED_DB_VERSION,
  ISO_4217_CURRENCY_CODE_CANADA_DOLLAR,
  ISO_4217_CURRENCY_CODE_BRITISH_POUND,
  DEFAULT_SUBSCRIPTION_PRICE_USD_HARDWARE,
  PRACTICAL_STREAM_INDEXED_DB_OFFLINE_MODE_SONGS_TABLE_NAME,
} from './config'
import {
  isFrench,
  isKorean,
  isSpanish,
  translate,
  isEnglish,
  LANGUAGE_CODE_FRENCH,
  LANGUAGE_CODE_KOREAN,
  LANGUAGE_CODE_ENGLISH,
  LANGUAGE_CODE_SPANISH,
  LANGUAGE_LOCALE_CODE_US_ENGLISH,
  LANGUAGE_LOCALE_CODE_UK_ENGLISH,
  LANGUAGE_LOCALE_CODE_SPAIN_SPANISH,
  LANGUAGE_LOCALE_CODE_FRANCE_FRENCH,
  LANGUAGE_LOCALE_CODE_SOUTH_KOREA_KOREAN,
} from './language'
import { Inter } from 'next/font/google'

export const ipv4Regex: RegExp =
  /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/

const ARWEAVE_HASH_REGEX: RegExp = /[a-zA-Z0-9_-]{43}/
const ARWEAVE_URI_REGEX: RegExp = /^ar?:\/\//i

export function uuidv4(): string {
  //@ts-ignore
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c: any) =>
    (
      c ^
      (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
    ).toString(16),
  )
}

export function netDateToDateFormattedMonthDayOnly(
  strDate: any,
  selectedLanguage: any,
) {
  let ret: string = ''
  try {
    let options: any = {
      month: '2-digit',
      day: 'numeric',
    }
    let raw: Date = new Date(Date.parse(strDate))
    if (isNotNullOrEmptyString(raw))
      ret = raw.toLocaleDateString(
        selectedLanguage == LANGUAGE_CODE_ENGLISH
          ? LANGUAGE_LOCALE_CODE_US_ENGLISH
          : selectedLanguage == LANGUAGE_CODE_SPANISH
            ? LANGUAGE_LOCALE_CODE_SPAIN_SPANISH
            : selectedLanguage == LANGUAGE_CODE_FRENCH
              ? LANGUAGE_LOCALE_CODE_FRANCE_FRENCH
              : selectedLanguage == LANGUAGE_CODE_KOREAN
                ? LANGUAGE_LOCALE_CODE_SOUTH_KOREA_KOREAN
                : selectedLanguage,
        options,
      )
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
    ret = ''
  }
  return ret?.length > 1 && ret[0] == '0' ? ret.substring(1) : ret
}

export function netDateToDateFormatted(
  strDate: any,
  selectedLanguage: any,
  twoDigitYear: boolean,
) {
  let ret: string = ''
  try {
    let options: any = {
      year: twoDigitYear ? '2-digit' : 'numeric',
      month: '2-digit',
      day: 'numeric',
    }
    let raw: Date = new Date(Date.parse(strDate))
    if (isNotNullOrEmptyString(raw))
      ret = raw.toLocaleDateString(
        selectedLanguage == LANGUAGE_CODE_ENGLISH
          ? LANGUAGE_LOCALE_CODE_US_ENGLISH
          : selectedLanguage == LANGUAGE_CODE_SPANISH
            ? LANGUAGE_LOCALE_CODE_SPAIN_SPANISH
            : selectedLanguage == LANGUAGE_CODE_FRENCH
              ? LANGUAGE_LOCALE_CODE_FRANCE_FRENCH
              : selectedLanguage == LANGUAGE_CODE_KOREAN
                ? LANGUAGE_LOCALE_CODE_SOUTH_KOREA_KOREAN
                : selectedLanguage,
        options,
      )
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
    ret = ''
  }
  return ret?.length > 1 && ret[0] == '0' ? ret.substring(1) : ret
}

const encryptionShift: number = 3

export function simpleEncrypt(text: any) {
  let encryptedText = ''
  try {
    for (let i = 0; i < text.length; i++) {
      let charCode = text.charCodeAt(i)
      if (charCode >= 32 && charCode <= 126)
        charCode = ((charCode - 32 + encryptionShift) % 95) + 32
      encryptedText += String.fromCharCode(charCode)
    }
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  return encryptedText
}

export function simpleDecrypt(encryptedText: any) {
  let decryptedText = ''
  try {
    for (let i = 0; i < encryptedText.length; i++) {
      let charCode = encryptedText.charCodeAt(i)
      if (charCode >= 32 && charCode <= 126)
        charCode = ((charCode - 32 - encryptionShift + 95) % 95) + 32
      decryptedText += String.fromCharCode(charCode)
    }
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  return decryptedText
}

export function markTime(marker: any) {
  try {
    if (IS_LOCAL) {
      console.log(marker.toString())
      console.log(new Date().getSeconds())
      console.log(new Date().getMilliseconds())
    }
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
}

export function netDateToDate(strDate: any): Date | null {
  let ret: Date | null = null
  try {
    ret = new Date(strDate)
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  return ret
}
export function netDateToDateOrEmptyString(strDate: any): Date | string {
  let ret: Date | string = ''
  try {
    let test = new Date(strDate)
    if (test != null) ret = test
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
    ret = ''
  }
  return ret
}

export function netDateToDateNicelyFormatted(
  strDate: any,
  selectedLanguage: any,
  omitYear: boolean,
) {
  let ret: string = ''
  try {
    if (
      isNotNullOrEmptyString(strDate) &&
      isNullOrEmptyString(selectedLanguage)
    )
      return netDateToDateFormatted(strDate, LANGUAGE_CODE_ENGLISH, false)
    else if (isNotNullOrEmptyString(strDate)) {
      let raw = new Date(strDate)
      if (isNotNullOrEmptyString(raw))
        ret = !omitYear
          ? raw.toLocaleDateString(
              selectedLanguage == LANGUAGE_CODE_ENGLISH
                ? LANGUAGE_LOCALE_CODE_US_ENGLISH
                : selectedLanguage == LANGUAGE_CODE_SPANISH
                  ? LANGUAGE_LOCALE_CODE_SPAIN_SPANISH
                  : selectedLanguage == LANGUAGE_CODE_FRENCH
                    ? LANGUAGE_LOCALE_CODE_FRANCE_FRENCH
                    : selectedLanguage == LANGUAGE_CODE_KOREAN
                      ? LANGUAGE_LOCALE_CODE_SOUTH_KOREA_KOREAN
                      : selectedLanguage,
              {
                month: 'long',
                day: 'numeric',
                year: 'numeric',
              },
            )
          : raw.toLocaleDateString(
              selectedLanguage == LANGUAGE_CODE_ENGLISH
                ? LANGUAGE_LOCALE_CODE_US_ENGLISH
                : selectedLanguage == LANGUAGE_CODE_SPANISH
                  ? LANGUAGE_LOCALE_CODE_SPAIN_SPANISH
                  : selectedLanguage == LANGUAGE_CODE_FRENCH
                    ? LANGUAGE_LOCALE_CODE_FRANCE_FRENCH
                    : selectedLanguage == LANGUAGE_CODE_KOREAN
                      ? LANGUAGE_LOCALE_CODE_SOUTH_KOREA_KOREAN
                      : selectedLanguage,
              {
                month: 'long',
                day: 'numeric',
              },
            )
    }
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
    ret = ''
  }
  return ret
}

export const BROKEN_SONG_IMAGE_ICON: string =
  HOST + '/images/c9c3f53e-2764-11ed-a261-0242ac120002.png'
const ARWEAVE_IMPORT_CDN_FOLDER: string = PRACTICAL_STREAM_CDN_ADDRESS + 'a/'
const USE_CDN_FOR_ALL_MUSIC_MEDIA: boolean = false
export const CURE_CDN_JPG_EXT: string = '.jpg'
export const CURE_CDN_MP3_EXT: string = '.mp3'
export const CURE_CDN_AVIF_EXT: string = '.avif'

export async function getOptimizedMediaUrl(
  input: any,
  extension: string,
): Promise<string> {
  const hashMatch = input.match(ARWEAVE_HASH_REGEX)
  if (!hashMatch) return toTrimmedString(input)
  const hash = hashMatch[0]
  const frmArweaveUrl: string = cureArweave(input)
  const cdnUrl = `${ARWEAVE_IMPORT_CDN_FOLDER}${hash}${extension}`
  if (USE_CDN_FOR_ALL_MUSIC_MEDIA && isNotNullOrEmptyString(hash)) return cdnUrl
  try {
    const res = await fetch(cdnUrl, {
      method: 'HEAD',
      cache: 'no-store',
    })
    return res.status === 200 || res.status === 202 ? cdnUrl : frmArweaveUrl
  } catch {
    return toTrimmedString(input)
  }
}

export function cureArweaveOld(url: any, extension: any) {
  let ret: any = toTrimmedString(url)
  const hashMatch = ret.match(/[a-zA-Z0-9_-]{43}/)
  try {
    if (extension != null && hashMatch != null)
      ret = `${ARWEAVE_IMPORT_CDN_FOLDER}${hashMatch[0]}${extension}`
    else if (ret.indexOf(PRACTICAL_STREAM_CDN_ADDRESS) == -1) {
      ret = ret.replace(ARWEAVE_GATEWAY_MAIN, ARWEAVE_GATEWAY)
      let matches = isNotNullOrEmptyString(ret)
        ? ret.match(ARWEAVE_URI_REGEX)
        : []
      if (matches?.length > 0 && isNotNullOrEmptyString(matches[0])) {
        ret = ret.replace(ARWEAVE_URI_REGEX, ARWEAVE_GATEWAY)
      }
    }
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  return ret
}

export function cureArweave(url: any) {
  let ret: any = toTrimmedString(url)
  ret = ret.replace(ARWEAVE_GATEWAY_MAIN, ARWEAVE_GATEWAY)
  let matches = isNotNullOrEmptyString(ret) ? ret.match(ARWEAVE_URI_REGEX) : []
  try {
    if (matches?.length > 0 && isNotNullOrEmptyString(matches[0])) {
      ret = ret.replace(ARWEAVE_URI_REGEX, ARWEAVE_GATEWAY)
    }
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  return ret
}

export function cureCDN(url: any, extension: any, isArtistMedia: boolean) {
  const input: string = toTrimmedString(url)
  const hashMatch: RegExpMatchArray | null = input.match(ARWEAVE_HASH_REGEX)
  const ext: any = isNotNullOrEmptyString(extension) ? extension : ''
  try {
    if (!hashMatch) return input
    const hash: string = hashMatch[0]
    const isArweaveSource: boolean =
      input.includes(ARWEAVE_GATEWAY) ||
      input.includes(ARWEAVE_GATEWAY_MAIN) ||
      ARWEAVE_URI_REGEX.test(input)
    if (isArweaveSource)
      return `${PRACTICAL_STREAM_CDN_ADDRESS}${isArtistMedia ? 'r1/' : 'a/'}${hash}${ext}`
    if (input.includes(PRACTICAL_STREAM_CDN_ADDRESS) && !input.endsWith(ext))
      return `${input}${ext}`
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  return input
}

export function isResolvedArweaveUrl(url: any) {
  let ret: boolean = false
  let trmUrl: any = toTrimmedString(url)
  try {
    const hashMatch = trmUrl.match(ARWEAVE_HASH_REGEX)
    if (
      hashMatch &&
      (trmUrl.indexOf(ARWEAVE_GATEWAY) > -1 ||
        trmUrl.indexOf(ARWEAVE_GATEWAY_MAIN) > -1)
    )
      ret = true
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  return ret
}

export function isValidHttpsUrl(str: string | null | undefined): boolean {
  if (!str || typeof str !== 'string') return false
  try {
    if (!URL.canParse(str)) return false
    const url = new URL(str)
    if (url.protocol !== 'https:') return false
    const hostnamePattern = /^[a-z0-9.-]+\.[a-z]{2,}$/i
    return (
      url.hostname.length > 0 &&
      hostnamePattern.test(url.hostname) &&
      !url.hostname.includes('..')
    )
  } catch {
    return false
  }
}

export const DATE_TO_NET_FUNCTION: string = `
  function dateToNetDate(strDate) {
    let ret = null
    try {
      if (strDate != null) {
        let date = new Date(strDate)
        let yr = date.getFullYear()
        if (yr <= 1970) ret = null
        else ret = date.toUTCString().replace('UTC', 'GMT')
      } else return ret
    } catch (e) {
      if (${DEBUG_MODE}) console.log(e)
      ret = null
    }
    return ret
  }
`

export function dateToNetDate(strDate: any): string {
  let ret: any = null
  try {
    if (strDate != null) {
      let date: Date = new Date(strDate)
      const yr: number = date.getFullYear()
      if (yr <= 1970) ret = null
      else ret = date.toUTCString().replace('UTC', 'GMT')
    } else return ret
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
    ret = ''
  }
  return ret
}

export function formatArtistNameBig(artistName: any): string {
  let ret: string = toTrimmedString(artistName)
  try {
    if (
      isNotNullOrEmptyString(artistName) &&
      artistName?.toString().trim().length > 99
    )
      ret = artistName?.toString().trim().substring(0, 98) + ' ... '
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
    ret = ''
  }
  return ret
}

export function formatArtistNameBigger(artistName: any): string {
  let ret: string = toTrimmedString(artistName)
  try {
    if (
      isNotNullOrEmptyString(artistName) &&
      artistName?.toString().trim().length > 149
    )
      ret = artistName?.toString().trim().substring(0, 148) + ' ... '
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
    ret = ''
  }
  return ret
}

export function toStringOrNull(s: any): string | null {
  return s && s?.toString().trim() != '' ? s?.toString().trim() : null
}

export const IS_NOT_NULL_OR_EMPTY_STRING_FUNCTION = `
function isNotNullOrEmptyString(s) {
  return s && s?.toString().trim() != '' ? true : false
}
`

export function isNotNullOrEmptyString(s: any): boolean {
  return s && s?.toString().trim() != '' ? true : false
}

export function isNullOrEmptyString(s: any): boolean {
  return !s || s?.toString().trim() == '' ? true : false
}

export function toTrimmedStringLowerCase(s: any): string {
  return s ? s?.toString().trim().toLowerCase() : ''
}

export function toTrimmedStringUpperCase(s: any): string {
  return s ? s?.toString().trim().toUpperCase() : ''
}

export const TO_TRIMMED_STRING_FUNCTION: string = `
 function toTrimmedString(s) {
    return s ? s?.toString().trim() : ''
  }
`

export function toTrimmedString(s: any): string {
  return s?.toString().trim() ?? ''
}

export const IS_NOT_NULL_OR_UNDEFINED_FUNCTION: string = `
  function isNotNullOrUndefined(s) {
    return s != null && s != undefined
  }
`

export function getTrimmedStringLength(s: any): number {
  return s?.toString().trim().length ?? 0
}

export function isNotNullOrUndefined(s: any): boolean {
  return s != null && s != undefined
}

export function isNullOrUndefined(s: any): boolean {
  return s == null || s == undefined
}

export function formatSongNameBig(songName: any) {
  return isNotNullOrEmptyString(songName)
    ? songName?.toString().trim().length > 49
      ? songName?.toString().trim().substring(0, 48) + ' ... '
      : songName
    : ''
}

export function formatSongNameSmall(songName: any): string {
  return isNotNullOrEmptyString(songName)
    ? songName?.toString().trim().length > 20
      ? songName?.toString().trim().substring(0, 19) + ' ... '
      : songName
    : ''
}

const NORMALIZE_SEARCH_VALUE_REGEXP: RegExp = /[.,/#!$%^&*;:{}=\-_`'~()\n\r]+/g

export function normalizeSearchValue(val: any): string {
  return isNotNullOrEmptyString(val)
    ? String(val)
        .trim()
        .replace(NORMALIZE_SEARCH_VALUE_REGEXP, ' ')
        .replace(/\s+/g, ' ')
        .toLowerCase()
    : ''
}

export function spaceEscapes(val: any): any {
  if (val?.length > 0) return val?.toString().replaceAll('\\n', ' ')
  else return val
}

export function getLiteral(val: any, lineHeight: any = '1.2'): JSX.Element {
  if (val?.length > 3 && val?.toString().trim().indexOf('...\\') > -1)
    val = val.toString().trim().replace('...\\', '...')
  else if (val?.length > 3 && val?.toString().trim().indexOf('... \\') > -1)
    val = val.toString().trim().replace('... \\', '...')
  val = val ? val.toString().trim().replace('\\xA9', '©') : ''
  val = val
    ? val
        .toString()
        .trim()
        .replace(/\\['"]+/g, '"')
    : ''
  val = val ? val.toString().trim().replace(/"/g, '"') : ''
  val = val ? val.toString().trim().replace(/\"/g, '"') : ''
  let lines: any = val
  try {
    if (val?.toString().indexOf('\\n') > -1) {
      lines = val.split('\\n').map(function (line: any, n: any) {
        return (
          <React.Fragment key={line}>
            {n == 0 ? [line] : [<br key={n} />, line]}
          </React.Fragment>
        )
      })
    } else {
      lines = Object(val)
        .split('\n')
        .map(function (line: any, n: any) {
          return (
            <React.Fragment key={line}>
              {n == 0 ? [line] : [<br key={n} />, line]}
            </React.Fragment>
          )
        })
    }
    return <div style={{ lineHeight: lineHeight }}>{lines}</div>
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  return <div style={{ lineHeight: lineHeight }}>{lines}</div>
}

export function getLiteralFitContent(val: any): JSX.Element {
  if (val?.length > 3 && val?.toString().trim().indexOf('...\\') > -1)
    val = val.toString().trim().replace('...\\', '...')
  else if (val?.length > 3 && val?.toString().trim().indexOf('... \\') > -1)
    val = val.toString().trim().replace('... \\', '...')
  val = val ? val.toString().trim().replace('\\xA9', '©') : ''
  val = val
    ? val
        .toString()
        .trim()
        .replace(/\\['"]+/g, '"')
    : ''
  val = val ? val.toString().trim().replace(/"/g, '"') : ''
  val = val ? val.toString().trim().replace(/\"/g, '"') : ''
  let lines: any = val
  try {
    if (val?.toString().indexOf('\\n') > -1) {
      lines = val.split('\\n').map(function (line: any, n: any) {
        return (
          <React.Fragment key={line}>
            {n == 0 ? [line] : [<br />, line]}
          </React.Fragment>
        )
      })
    } else {
      lines = Object(val)
        .split('\n')
        .map(function (line: any, n: any) {
          return (
            <React.Fragment key={line}>
              {n == 0 ? [line] : [<br />, line]}
            </React.Fragment>
          )
        })
    }
    return <div style={{ width: 'max-content' }}>{lines}</div>
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  return <div style={{ width: 'max-content' }}>{lines}</div>
}

export function getLiteralNoWrapper(val: any): any {
  if (val?.length > 3 && val?.toString().trim().indexOf('...\\') > -1)
    val = val.toString().trim().replace('...\\', '...')
  else if (val?.length > 3 && val?.toString().trim().indexOf('... \\') > -1)
    val = val.toString().trim().replace('... \\', '...')
  val = val ? val.toString().trim().replace('\\xA9', '©') : ''
  val = val
    ? val
        .toString()
        .trim()
        .replace(/\\['"]+/g, '"')
    : ''
  val = val ? val.toString().trim().replace(/"/g, '"') : ''
  val = val ? val.toString().trim().replace(/\"/g, '"') : ''
  let lines: any = val
  try {
    if (val?.toString().indexOf('\\n') > -1) {
      lines = val.split('\\n').map(function (line: any, n: any) {
        return (
          <React.Fragment key={line}>
            {n == 0 ? [line] : [<br />, line]}
          </React.Fragment>
        )
      })
    } else {
      lines = Object(val)
        .split('\n')
        .map(function (line: any, n: any) {
          return (
            <React.Fragment key={line}>
              {n == 0 ? [line] : [<br />, line]}
            </React.Fragment>
          )
        })
    }
    return lines
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  return lines
}

export function cureLiterals(val: any): string {
  let ret: string = val ? toTrimmedString(val) : ''
  try {
    ret = ret?.toString().trim().replace(/\\n/gi, ' ')
    ret = ret?.toString().trim().replace(/\\xA9/gi, ' ')
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  return ret
}

export function getMintDate(mint_date: any) {
  let ret: any = null
  try {
    ret = isNotNullOrEmptyString(mint_date)
      ? isNumeric(mint_date)
        ? Date.parse(
            new Date(parseInt(mint_date?.toString().trim() + '000'))
              .toString()
              .trim(),
          )
        : Date.parse(dateToNetDate(mint_date))
      : null
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  return ret
}

export const FORMAT_SONG_NAME_BIGGER_FUNCTION: string = `
  function formatSongNameBigger(songName) {
    let ret = songName
    try {
      if (
        songName != null &&
        songName != undefined &&
        songName?.toString().trim() != '' &&
        songName?.toString().trim().length > 99
      )
        ret = songName?.toString().trim().substring(0, 98) + ' ... '
    } catch (e) {
      if (${DEBUG_MODE}) console.log(e)
      ret = ''
    }
    return ret
  }
`

export function formatSongNameBigger(songName: any): string {
  return isNotNullOrEmptyString(songName)
    ? songName?.toString().trim().length > 99
      ? songName?.toString().trim().substring(0, 98) + ' ... '
      : songName
    : ''
}

const FORMAT_PLAYLIST_NAME_SMALL_LENGTH: number = 10

export function formatPlaylistNameSmall_OneWordDependent(
  playlistName: any,
): string {
  if (!isNotNullOrEmptyString(playlistName)) return ''
  const trimmedName = playlistName.toString().trim()
  const words = trimmedName.split(/\s+/)
  const hasLongWord = words.some(
    (word: string) => word.length > FORMAT_PLAYLIST_NAME_SMALL_LENGTH,
  )
  if (hasLongWord)
    return trimmedName.substring(0, FORMAT_PLAYLIST_NAME_SMALL_LENGTH) + ' ... '
  return trimmedName
}

const FORMAT_PLAYLIST_NAME_SMALL_MEDIUM_LENGTH: number = 13

export function formatPlaylistNameSmallMedium_OneWordDependent(
  playlistName: any,
): string {
  if (!isNotNullOrEmptyString(playlistName)) return ''
  const trimmedName = playlistName.toString().trim()
  const words = trimmedName.split(/\s+/)
  const hasLongWord = words.some(
    (word: string) => word.length > FORMAT_PLAYLIST_NAME_SMALL_MEDIUM_LENGTH,
  )
  if (hasLongWord)
    return (
      trimmedName.substring(0, FORMAT_PLAYLIST_NAME_SMALL_MEDIUM_LENGTH) +
      ' ... '
    )
  return trimmedName
}

const FORMAT_PLAYLIST_NAME_LENGTH: number = 20

export function formatPlaylistName(playlistName: any): string {
  return isNotNullOrEmptyString(playlistName)
    ? playlistName?.toString().trim().length > FORMAT_PLAYLIST_NAME_LENGTH + 1
      ? playlistName
          ?.toString()
          .trim()
          .substring(0, FORMAT_PLAYLIST_NAME_LENGTH) + ' ... '
      : playlistName
    : ''
}

const FORMAT_PLAYLIST_NAME_ONE_WORD_DEPENDENT_LENGTH: number = 15

export function formatPlaylistName_OneWordDependent(playlistName: any): string {
  if (!isNotNullOrEmptyString(playlistName)) return ''
  const trimmedName = playlistName.toString().trim()
  const words = trimmedName.split(/\s+/)
  const hasLongWord = words.some(
    (word: string) =>
      word.length > FORMAT_PLAYLIST_NAME_ONE_WORD_DEPENDENT_LENGTH,
  )
  if (hasLongWord)
    return (
      trimmedName.substring(0, FORMAT_PLAYLIST_NAME_ONE_WORD_DEPENDENT_LENGTH) +
      ' ... '
    )
  return trimmedName
}

const FORMAT_PLAYLIST_NAME_BIG_LENGTH: number = 32

export function formatPlaylistNameBig(playlistName: any): string {
  return isNotNullOrEmptyString(playlistName)
    ? playlistName?.toString().trim().length >
      FORMAT_PLAYLIST_NAME_BIG_LENGTH + 1
      ? playlistName
          ?.toString()
          .trim()
          .substring(0, FORMAT_PLAYLIST_NAME_BIG_LENGTH) + ' ... '
      : playlistName
    : ''
}

const FORMAT_PLAYLIST_NAME_BIGGER_LENGTH: number = 42
export const FORMAT_PLAYLIST_NAME_BIGGER_LENGTH_PLUS_TEN: number =
  FORMAT_PLAYLIST_NAME_BIGGER_LENGTH + 10

export function formatPlaylistNameBigger(playlistName: any): string {
  return isNotNullOrEmptyString(playlistName)
    ? playlistName?.toString().trim().length >
      FORMAT_PLAYLIST_NAME_BIGGER_LENGTH + 1
      ? playlistName
          ?.toString()
          .trim()
          .substring(0, FORMAT_PLAYLIST_NAME_BIGGER_LENGTH) + ' ...'
      : playlistName
    : ''
}

const FORMAT_SCHEDULE_TEMPLATE_NAME_SMALL_LENGTH: number = 20

export function formatScheduleTemplateName(templateName: any): string {
  return isNotNullOrEmptyString(templateName)
    ? templateName?.toString().trim().length >
      FORMAT_SCHEDULE_TEMPLATE_NAME_SMALL_LENGTH + 1
      ? templateName
          ?.toString()
          .trim()
          .substring(0, FORMAT_SCHEDULE_TEMPLATE_NAME_SMALL_LENGTH) + ' ...'
      : templateName
    : ''
}

export function formatDuration(
  duration: any,
  leadingMinutesZero: boolean,
): string {
  let ret: string = ''
  try {
    const date: any = new Date(duration)
    const hours: any = date.getUTCHours()
    const hasHours: boolean =
      isNotNullOrEmptyString(hours) && toTrimmedString(hours) != '0'
    const minutes: any = date.getUTCMinutes()
    const seconds: any = date.getUTCSeconds()
    ret =
      (hasHours ? toTrimmedString(hours) + ':' : '') +
      (isNotNullOrEmptyString(minutes) && !hasHours
        ? leadingMinutesZero && minutes < 10
          ? '0' + toTrimmedString(minutes)
          : toTrimmedString(minutes)
        : isNotNullOrEmptyString(minutes) && hasHours
          ? '0' + toTrimmedString(minutes)
          : !minutes || (toTrimmedString(minutes) == '' && hasHours)
            ? '0'
            : '00') +
      ':' +
      (isNotNullOrEmptyString(seconds)
        ? seconds < 10
          ? '0' + toTrimmedString(seconds)
          : toTrimmedString(seconds)
        : '00')
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
    ret = ''
  }
  return ret
}

export function decodeUnicode(str: any): string {
  let ret: string = ''
  try {
    ret = Buffer.from(toTrimmedString(str), 'base64').toString('utf8')
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  return ret
}

export function encodeUnicode(str: any): any {
  let ret: any = null
  try {
    ret = btoa(unescape(encodeURIComponent(str ? str?.toString().trim() : '')))
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  return ret
}

export const ONLY_UNIQUE_FUNCTION: string = `
function onlyUnique(value, index, self) {
  try {
    return self.indexOf(value) === index
  } catch (e) {
    if (${DEBUG_MODE}) console.log(e)
  }
}
`

export function getUniqueByFields(arr: any, fields: any): any[] {
  let unique = []
  try {
    const seenKeys = new Set()
    for (const obj of arr) {
      const key = fields.map((field: string | number) => obj[field]).join('|')
      if (!seenKeys.has(key)) {
        seenKeys.add(key)
        unique.push(obj)
      }
    }
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  return unique
}

export function onlyUnique(
  value: any,
  index: any,
  self: any,
): boolean | undefined {
  try {
    return self.indexOf(value) === index
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
}

export function isSamePlaylist(
  songs_Master: any,
  playlistSongs: any,
  lastClickedPlaylistId: any,
  playlistId: any,
): boolean {
  let ret: boolean = false
  try {
    if (
      lastClickedPlaylistId > 0 &&
      lastClickedPlaylistId == playlistId &&
      songs_Master?.length > 0 &&
      playlistSongs?.length > 0
    ) {
      const compare: any = songs_Master.slice(
        songs_Master?.length - playlistSongs?.length,
      )
      if (compare?.length > 0 && compare?.length == playlistSongs?.length) {
        compare?.map((c: any, i: number) => {
          ret = isNotNullOrEmptyString(c?.contract_address)
          c?.contract_address == playlistSongs[i]?.contract_address &&
            isNotNullOrEmptyString(c?.token_id) &&
            c?.token_id == playlistSongs[i]?.token_id
        })
      }
    }
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  return ret
}

export function isSameSong(
  aContractAddress: any,
  aTokenId: any,
  bContractAddress: any,
  bTokenId: any,
): boolean {
  return aContractAddress == bContractAddress && aTokenId == bTokenId
}

export function isNumeric(str: any): boolean {
  return isNotNullOrEmptyString(str) && !isNaN(str) && !isNaN(parseFloat(str))
}

export function IconSparklesCustom(size: any, strokeColor: any) {
  return (
    <svg
      xmlns="w3.org"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={strokeColor}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path
        d="M12 4.5c.132 2.643 1.357 3.868 4 4-2.643.132-3.868 1.357-4 4-.132-2.643-1.357-3.868-4-4 2.643-.132 3.868-1.357 4-4z"
        fill={strokeColor}
      />
      <path d="M19 12.5c.066 1.321.678 1.934 2 2-1.322.066-1.934.679-2 2-.066-1.321-.678-1.934-2-2 1.322-.066 1.934-.679 2-2z" />
      <path d="M5 14.5c.066 1.321.678 1.934 2 2-1.322.066-1.934.679-2 2-.066-1.321-.678-1.934-2-2 1.322-.066 1.934-.679 2-2z" />
    </svg>
  )
}

export async function fetchWithTimeout(
  resource: any,
  options: any = {},
): Promise<any> {
  let response: any = null
  try {
    const { timeout = 2000 } = options
    const controller: any = new AbortController()
    let id: NodeJS.Timeout | null = setTimeout(
      () => controller.abort(),
      timeout,
    )
    response = await fetch(resource, {
      ...options,
      signal: controller.signal,
    })
    try {
      if (id != null) {
        clearTimeout(id)
        id = null
      }
    } catch {}
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  return response
}

export const trackLengths: any[] = [
  {
    label: '00.30-01.00',
    value: '00.30-01.00',
  },
  {
    label: '01.00-02.00',
    value: '01.00-02.00',
  },
  {
    label: '02.00-03.00',
    value: '02.00-03.00',
  },
  {
    label: '03.00-05.00',
    value: '03.00-05.00',
  },
  {
    label: '05.00+',
    value: '05.00+',
  },
]

export function sortOptions(selectedLanguage: any): any[] {
  return [
    {
      label: translate('Title', 'Título', 'Titre', '이름', selectedLanguage),
      value: 'Title (A to Z)',
      direction: 'up',
      type: 'alphabetical',
    },
    {
      label: translate('Title', 'Título', 'Titre', '이름', selectedLanguage),
      value: 'Title (Z to A)',
      direction: 'down',
      type: 'alphabetical',
    },
    {
      label: translate(
        'Length',
        'Duración',
        'Durées',
        '길이',
        selectedLanguage,
      ),
      value: 'Track Length (Low)',
      direction: 'up',
      type: 'numeric',
    },
    {
      label: translate(
        'Length',
        'Duración',
        'Durées',
        '길이',
        selectedLanguage,
      ),
      value: 'Track Length (High)',
      direction: 'down',
      type: 'numeric',
    },
    {
      label: translate(
        'Drop Date',
        'Acuñar Fecha',
        'Date de la Monnayer',
        '생산 일',
        selectedLanguage,
      ),
      value: 'Drop Date (High)',
      direction: 'down',
      type: 'datetime',
    },
    {
      label: translate(
        'Drop Date',
        'Acuñar Fecha',
        'Date de la Monnayer',
        '생산 일',
        selectedLanguage,
      ),
      value: 'Drop Date (Low)',
      direction: 'up',
      type: 'datetime',
    },
  ]
}

export function favoritesSortOptions(selectedLanguage: any): any[] {
  return [
    {
      label: translate(
        'Added',
        'Agregada',
        'Ajoutée',
        '생성 날짜',
        selectedLanguage,
      ),
      value: 'Added (High)',
      direction: 'down',
      type: 'datetime',
    },
    {
      label: translate(
        'Added',
        'Agregada',
        'Ajoutée',
        '생성 날짜',
        selectedLanguage,
      ),
      value: 'Added (Low)',
      direction: 'up',
      type: 'datetime',
    },
    {
      label: translate('Title', 'Título', 'Titre', '이름', selectedLanguage),
      value: 'Title (A to Z)',
      direction: 'up',
      type: 'alphabetical',
    },
    {
      label: translate('Title', 'Título', 'Titre', '이름', selectedLanguage),
      value: 'Title (Z to A)',
      direction: 'down',
      type: 'alphabetical',
    },
    {
      label: translate(
        'Length',
        'Duración',
        'Durées',
        '길이',
        selectedLanguage,
      ),
      value: 'Track Length (Low)',
      direction: 'up',
      type: 'numeric',
    },
    {
      label: translate(
        'Length',
        'Duración',
        'Durées',
        '길이',
        selectedLanguage,
      ),
      value: 'Track Length (High)',
      direction: 'down',
      type: 'numeric',
    },
    {
      label: translate(
        'Drop Date',
        'Acuñar Fecha',
        'Date de la Monnayer',
        '생산 일',
        selectedLanguage,
      ),
      value: 'Drop Date (High)',
      direction: 'down',
      type: 'datetime',
    },
    {
      label: translate(
        'Drop Date',
        'Acuñar Fecha',
        'Date de la Monnayer',
        '생산 일',
        selectedLanguage,
      ),
      value: 'Drop Date (Low)',
      direction: 'up',
      type: 'datetime',
    },
  ]
}

export const SHOW_MORE_VALUE_100: number = 100
export const SHOW_MORE_VALUE_200: number = 200
export const SHOW_MORE_VALUE_ALL: number = -1

export function showMoreOptions(selectedLanguage: any): any[] {
  return [
    {
      label: translate(
        'Show 100',
        'Mostrar 100',
        'Afficher 100',
        '100개 표시',
        selectedLanguage,
      ),
      value: SHOW_MORE_VALUE_100,
    },
    {
      label: translate(
        'Show 200',
        'Mostrar 200',
        'Afficher 200',
        '200개 표시',
        selectedLanguage,
      ),
      value: SHOW_MORE_VALUE_200,
    },
    {
      label: translate(
        'Show All',
        'Mostrar Todo',
        'Afficher Tout',
        '모두 표시',
        selectedLanguage,
      ),
      value: SHOW_MORE_VALUE_ALL,
    },
  ]
}

export function getSubscriptionPriceValidUntil(): string | null {
  let ret: string | null = null
  try {
    ret = (new Date().getFullYear() + 1).toString() + '-12-31T23:59:59+00:00'
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  return ret
}

export const UNITED_STATES_ISO_3166_ALPHA_2_CODE: string = 'US'
export const CANADA_ISO_3166_ALPHA_2_CODE: string = 'CA'
export const BRITAIN_ISO_3166_ALPHA_2_CODE: string = 'GB'
export const BRITAIN_ISO_3166_ALPHA_2_CODE_ALT: string = 'UK'
export const BRITAIN_ISO_3166_ALPHA_2_CODE_WALES: string = 'GB-ENG'
export const SOUTH_KOREA_ISO_3166_ALPHA_2_CODE: string = 'KR'
export const FRANCE_ISO_3166_ALPHA_2_CODE: string = 'FR'
export const SPAIN_ISO_3166_ALPHA_2_CODE: string = 'ES'
export const AUSTRIA_ISO_3166_ALPHA_2_CODE: string = 'AT'
export const BELGIUM_ISO_3166_ALPHA_2_CODE: string = 'BE'
export const CYPRUS_ISO_3166_ALPHA_2_CODE: string = 'CY'
export const GERMANY_ISO_3166_ALPHA_2_CODE: string = 'DE'
export const ESTONIA_ISO_3166_ALPHA_2_CODE: string = 'EE'
export const FINLAND_ISO_3166_ALPHA_2_CODE: string = 'FI'
export const GREECE_ISO_3166_ALPHA_2_CODE: string = 'GR'
export const CROATIA_ISO_3166_ALPHA_2_CODE: string = 'HR'
export const IRELAND_ISO_3166_ALPHA_2_CODE: string = 'IE'
export const ITALY_ISO_3166_ALPHA_2_CODE: string = 'IT'
export const LUXEMBOURG_ISO_3166_ALPHA_2_CODE: string = 'LU'
export const LATVIA_ISO_3166_ALPHA_2_CODE: string = 'LV'
export const LITHUANIA_ISO_3166_ALPHA_2_CODE: string = 'LT'
export const MALTA_ISO_3166_ALPHA_2_CODE: string = 'MT'
export const NETHERLANDS_ISO_3166_ALPHA_2_CODE: string = 'NL'
export const PORTUGAL_ISO_3166_ALPHA_2_CODE: string = 'PT'
export const SLOVENIA_ISO_3166_ALPHA_2_CODE: string = 'SI'
export const SLOVAKIA_ISO_3166_ALPHA_2_CODE: string = 'SK'
export const ANDORRA_ISO_3166_ALPHA_2_CODE: string = 'AD'
export const MONACO_ISO_3166_ALPHA_2_CODE: string = 'MC'
export const SAN_MARINO_ISO_3166_ALPHA_2_CODE: string = 'SM'
export const VATICAN_CITY_ISO_3166_ALPHA_2_CODE: string = 'VA'
export const MONTENEGRO_ISO_3166_ALPHA_2_CODE: string = 'ME'
export const KOSOVO_ISO_3166_ALPHA_2_CODE: string = 'XK'

export const EURO_CURRENCY_ISO_3166_ALPHA_2_COUNTRY_CODES: any[] = [
  'AT',
  'BE',
  'HR',
  'CY',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PT',
  'SK',
  'SI',
  'ES',
]

export const alphabet: any[] = [
  { label: 'A-C', value: ['a', 'b', 'c'] },
  { label: 'D-F', value: ['d', 'e', 'f'] },
  { label: 'G-I', value: ['g', 'h', 'i'] },
  { label: 'J-L', value: ['j', 'k', 'l'] },
  { label: 'M-O', value: ['m', 'n', 'o'] },
  { label: 'P-R', value: ['p', 'q', 'r'] },
  { label: 'S-U', value: ['s', 't', 'u'] },
  { label: 'V-X', value: ['v', 'w', 'x'] },
  { label: 'Y-Z', value: ['y', 'z'] },
  { label: '*', value: ['*'] },
]

export const inter = Inter({
  subsets: ['latin'],
  variable: '--font-inter',
})

export function formatTwoDecimalPoints(amt: any): string {
  let ret: string = '0.00'
  try {
    ret = amt > 0 ? (Math.round(amt * 100) / 100).toFixed(2) : '0.00'
  } catch (e) {
    if (DEBUG_MODE) console.log(amt)
  }
  return ret
}

export function formatDecimalComma(amt: any, locale: string = 'en'): string {
  try {
    const parsedAmount = parseFloat(amt)
    if (isNaN(parsedAmount) || parsedAmount <= 0) {
      return new Intl.NumberFormat(locale, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(0)
    }
    return new Intl.NumberFormat(locale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(parsedAmount)
  } catch (e) {
    if (DEBUG_MODE) console.log(amt, e)
    return '0.00'
  }
}

export function formatInteger(amt: any, locale: string = 'en'): string {
  try {
    const parsedAmount = parseInt(amt, 10)
    if (isNaN(parsedAmount) || parsedAmount <= 0) {
      return new Intl.NumberFormat(locale).format(0)
    }
    return new Intl.NumberFormat(locale, {
      maximumFractionDigits: 0,
    }).format(parsedAmount)
  } catch (e) {
    if (DEBUG_MODE) console.log(amt, e)
    return '0'
  }
}

export function getSubscriptionButtonCurrencyText(
  currency: string,
  subscriptionPrice: string | number,
  USDSubscriptionPrice: string | number,
  selLang: string,
  defaultHardware: boolean,
): string {
  let retVal: string = ''
  try {
    const isFrancais: boolean = isFrench(selLang)

    const defaultUsd = defaultHardware
      ? DEFAULT_SUBSCRIPTION_PRICE_USD_HARDWARE
      : DEFAULT_SUBSCRIPTION_PRICE_USD
    let price = toTrimmedString(subscriptionPrice)
    let currencySymbol = CURRENCY_SYMBOL_US_DOLLAR
    if (isNotNullOrEmptyString(currency) && price !== '0') {
      const symbolMap: Record<string, string> = {
        [ISO_4217_CURRENCY_CODE_EURO]: CURRENCY_SYMBOL_EURO,
        [ISO_4217_CURRENCY_CODE_BRITISH_POUND]: CURRENCY_SYMBOL_BRITISH_POUND,
        [ISO_4217_CURRENCY_CODE_CANADA_DOLLAR]: CURRENCY_SYMBOL_CANADA_DOLLAR,
        [ISO_4217_CURRENCY_CODE_US_DOLLAR]: CURRENCY_SYMBOL_US_DOLLAR,
      }
      currencySymbol = symbolMap[currency] || CURRENCY_SYMBOL_US_DOLLAR
    } else {
      price =
        isNotNullOrEmptyString(USDSubscriptionPrice) &&
        toTrimmedString(USDSubscriptionPrice) !== defaultUsd
          ? toTrimmedString(USDSubscriptionPrice)
          : defaultUsd
      currencySymbol = CURRENCY_SYMBOL_US_DOLLAR
    }
    if (isFrancais) {
      const frenchPrice: string = price.replace('.', ',')
      retVal = `${frenchPrice} ${currencySymbol}`
    } else {
      retVal = `${currencySymbol}${price}`
    }
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  return retVal
}

export function numberWithCommas(x: any): string {
  let ret: string = ''
  try {
    ret = isNotNullOrEmptyString(x)
      ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      : ''
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  return ret
}

export function numberWithSpaces(x: any): string {
  let ret: string = ''
  try {
    ret = isNotNullOrEmptyString(x)
      ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
      : ''
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  return ret
}

export function formatUnixTimestamp(
  timestamp: any,
  selectedLanguage: any,
  localCurrency: any,
): string {
  let ret: string = ''
  try {
    let lcaseLocalCurrency = toTrimmedStringLowerCase(localCurrency)
    let chosenLanguage = isKorean(selectedLanguage)
      ? selectedLanguage
      : isFrench(selectedLanguage)
        ? lcaseLocalCurrency ==
          toTrimmedStringLowerCase(ISO_4217_CURRENCY_CODE_CANADA_DOLLAR)
          ? selectedLanguage + '-CA'
          : selectedLanguage
        : isSpanish(selectedLanguage)
          ? lcaseLocalCurrency ==
            toTrimmedStringLowerCase(ISO_4217_CURRENCY_CODE_US_DOLLAR)
            ? selectedLanguage
            : selectedLanguage + '-ES'
          : isEnglish(selectedLanguage)
            ? lcaseLocalCurrency ==
              toTrimmedStringLowerCase(ISO_4217_CURRENCY_CODE_BRITISH_POUND)
              ? LANGUAGE_LOCALE_CODE_UK_ENGLISH
              : selectedLanguage
            : selectedLanguage
    const d: Date = new Date(timestamp * 1000)
    const formatObj: Intl.DateTimeFormatPart[] = new Intl.DateTimeFormat(
      chosenLanguage,
    ).formatToParts(d)
    const yyyy: number = d.getFullYear()
    const mm: string = ('0' + (d.getMonth() + 1)).slice(-2)
    const dd: string = ('0' + d.getDate()).slice(-2)
    ret = formatObj
      .map((obj) => {
        switch (obj?.type) {
          case 'day':
            return dd
          case 'month':
            return mm
          case 'year':
            return yyyy
          default:
            return obj?.value
        }
      })
      .join('')
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  if (ret?.length > 1 && ret[0] == '0') ret = ret.substring(1)
  if (ret?.length > 1) ret = ret.replace('/0', '/')
  return ret
}

export const validEmailRegex: RegExp =
  /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/

export function isInternalReferer(referer: any): boolean {
  return (
    toTrimmedStringLowerCase(referer).indexOf(toTrimmedStringLowerCase(HOST)) ==
    0
  )
}

export const internationalCurrencies: any[] = [
  {
    value: toTrimmedStringLowerCase(ISO_4217_CURRENCY_CODE_US_DOLLAR),
    label: CURRENCY_SYMBOL_US_DOLLAR,
    src: '/images/03494325-9D14-455D-9FC6-DBF2AF44A4C1.png',
  },
  {
    value: toTrimmedStringLowerCase(ISO_4217_CURRENCY_CODE_EURO),
    label: CURRENCY_SYMBOL_EURO,
    src: '/images/6BDC6F46-E8FE-4071-BABC-700C2C1A7F04.png',
  },
  {
    value: toTrimmedStringLowerCase(ISO_4217_CURRENCY_CODE_BRITISH_POUND),
    label: CURRENCY_SYMBOL_BRITISH_POUND,
    src: '/images/6025063F-88F1-494D-8B46-5B79FEDB56CD.png',
  },
  {
    value: toTrimmedStringLowerCase(ISO_4217_CURRENCY_CODE_CANADA_DOLLAR),
    label: CURRENCY_SYMBOL_CANADA_DOLLAR,
    src: '/images/2BD0097E-3601-475C-9E2F-A1133BBDDDE2.jpg',
  },
]

export const formatActionValue = (value: any, decimals: number = 1): string => {
  let retVal: string = ''
  try {
    if (isNotNullOrEmptyString(value)) {
      let tryNum: number = parseInt(value)
      retVal = new Intl.NumberFormat('en-US', {
        notation: 'compact',
        compactDisplay: 'short',
        maximumFractionDigits: decimals,
      })
        .format(tryNum)
        .toLowerCase()
    }
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  return retVal
}

export function isInvalidTimeComparison(
  startTimeStr: string,
  endTimeStr: string,
) {
  let ret: boolean = false
  try {
    const today = new Date()
    const parseTime: any = (timeStr: any) => {
      const [time, ampm] = timeStr.split(' ')
      let [hours, minutes] = time.split(':').map(Number)
      if (ampm === 'PM' && hours !== 12) hours += 12
      else if (ampm === 'AM' && hours === 12) hours = 0
      const date = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate(),
        hours,
        minutes,
      )
      return date
    }

    const startTime = parseTime(startTimeStr)
    const endTime = parseTime(endTimeStr)
    ret = endTime.getTime() <= startTime.getTime()
  } catch (e: any) {
    if (DEBUG_MODE) console.log(e)
  }
  return ret
}

export function extractHoursAndMinutes(timeString: any): any {
  let ret: any = null
  try {
    const isPM: boolean = timeString?.toString().indexOf('PM') > -1
    let hoursRaw = timeString.substring(0, timeString.toString().indexOf(':'))
    const hoursNum: number = hoursRaw == '12' ? 0 : parseInt(hoursRaw)
    if (isPM) hoursRaw = (hoursNum + 12).toString()
    else hoursRaw = hoursNum?.toString()
    const minutesRaw = timeString.substring(
      timeString.toString().indexOf(':') + 1,
      timeString.toString().indexOf(' ', timeString.toString().indexOf(':')),
    )
    let formatted =
      (hoursRaw?.toString().length == 1 ? '0' + hoursRaw : hoursRaw) +
      ':' +
      (minutesRaw?.toString().length == 1 ? '0' + minutesRaw : minutesRaw) +
      ':00'
    const date = new Date('1970-01-01T' + formatted)
    const hours = date.getHours()
    const minutes = date.getMinutes()
    ret = hours * 60 + minutes
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  return ret
}

export function constructHoursAndMinutesString(sumMinutes: any): string | null {
  let ret: string | null = null
  try {
    let hours: number = Math.floor(sumMinutes / 60)
    let minutes: number = sumMinutes - hours * 60
    let isPM: boolean = hours >= 12
    ret =
      (hours > 0
        ? hours == 10 || hours == 11 || hours == 12
          ? hours?.toString()
          : hours == 22 || hours == 23 || hours == 24
            ? (hours - 12)?.toString()
            : '0' + (isPM ? (hours - 12).toString() : hours?.toString())
        : '12') +
      ':' +
      (minutes > 0
        ? minutes > 9
          ? minutes?.toString()
          : '0' + minutes?.toString()
        : '00') +
      (isPM ? ' PM' : ' AM')
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  return ret
}

export function makeInvitationToken(): string {
  let str: string = uuidv4()
  str = str.toString().substring(0, 7)
  let ret: string = ''
  try {
    let hash = 0
    for (let i = 0; i < str.length; i++) {
      const char = str.charCodeAt(i)
      hash = (hash << 5) - hash + char
    }
    ret = (hash >>> 0).toString(36).padStart(7, '0')
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  return ret
}

export const parseDelimitedEmails = (inputText: any) => {
  if (!inputText) return []
  let ret: any = []
  try {
    const rawItems = inputText.split(/[\s,;]+/)
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    ret = rawItems
      .map((item: any) => item.trim())
      .filter((item: any) => emailRegex.test(item))
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  return ret
}

export function makeInvitationLink(token: any): string {
  let ret: string = ''
  try {
    ret = HOST + '/settings?g=' + toTrimmedString(token)
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  return ret
}

export const analyzeBulkEmailInput = (
  text: string | null | undefined,
  web2UserSessionId: string | null | undefined,
  existentUsers: string[] = [],
  existentInvitations: string[] = [],
  skippedUsers: string[] = [],
  skippedInvitations: string[] = [],
  unsubscribedSkipped: string[] = [],
  crossTenantSkipped: string[] = [],
) => {
  let ret: {
    validCount: number
    validEmails: string[]
    hasInvalids: boolean
    includesAdminsEmail: boolean
    hasExistentUsers: boolean
    hasExistentInvitations: boolean
    hasReusedInvalidEmails: boolean
  } = {
    validCount: 0,
    validEmails: [],
    hasInvalids: false,
    includesAdminsEmail: false,
    hasExistentUsers: false,
    hasExistentInvitations: false,
    hasReusedInvalidEmails: false,
  }
  if (!text || !text.trim()) {
    return ret
  }
  try {
    const rawTokens: string[] = text
      .split(/[\s,;]+/)
      .filter((token) => token.length > 0)
    const allEmails: string[] = parseDelimitedEmails(text)
    const hasReusedInvalidEmails =
      allEmails.length > 0
        ? allEmails.some(
            (ae: string) =>
              (skippedUsers?.length > 0 &&
                !skippedUsers.some(
                  (su: any) =>
                    toTrimmedStringLowerCase(su) ===
                    toTrimmedStringLowerCase(ae),
                )) ||
              (skippedInvitations?.length > 0 &&
                !skippedInvitations.some(
                  (si: any) =>
                    toTrimmedStringLowerCase(si) ===
                    toTrimmedStringLowerCase(ae),
                )) ||
              (unsubscribedSkipped?.length > 0 &&
                !unsubscribedSkipped.some(
                  (us) =>
                    toTrimmedStringLowerCase(us) ===
                    toTrimmedStringLowerCase(ae),
                )) ||
              (crossTenantSkipped?.length > 0 &&
                !crossTenantSkipped.some(
                  (cts: any) =>
                    toTrimmedStringLowerCase(cts) ===
                    toTrimmedStringLowerCase(ae),
                )),
          )
        : false
    const adminEmailNormalized = toTrimmedStringLowerCase(web2UserSessionId)
    let sansExistentUsers: string[] =
      allEmails.length > 0 && existentUsers.length > 0
        ? allEmails.filter(
            (ae: string) =>
              !existentUsers.some(
                (eu: any) =>
                  toTrimmedStringLowerCase(eu?.web2Email) ===
                  toTrimmedStringLowerCase(ae),
              ),
          )
        : allEmails
    const hasExistentUsers =
      allEmails?.length > 0 && allEmails?.length > sansExistentUsers?.length
    let sansExistentUsersAndInvitations: string[] =
      sansExistentUsers.length > 0 && existentInvitations.length > 0
        ? sansExistentUsers.filter(
            (se: string) =>
              !existentInvitations.some(
                (ei: any) =>
                  toTrimmedStringLowerCase(ei?.email) ===
                  toTrimmedStringLowerCase(se),
              ),
          )
        : sansExistentUsers
    const includesAdminsEmail: boolean =
      sansExistentUsersAndInvitations.length > 0 &&
      sansExistentUsersAndInvitations.some(
        (uv: string) => toTrimmedStringLowerCase(uv) === adminEmailNormalized,
      )
    let validEmails =
      sansExistentUsersAndInvitations?.length > 0
        ? sansExistentUsersAndInvitations.filter(
            (seuai: string) =>
              toTrimmedStringLowerCase(seuai) != adminEmailNormalized,
          )
        : []
    const hasExistentInvitations =
      sansExistentUsers?.length > 0 &&
      sansExistentUsers?.length > validEmails?.length
    const uniqueValids: string[] = [...new Set(validEmails)]
    const hasInvalids: boolean = rawTokens.length > uniqueValids.length
    ret = {
      validCount: uniqueValids.length,
      validEmails: uniqueValids,
      hasInvalids,
      includesAdminsEmail,
      hasExistentUsers,
      hasExistentInvitations,
      hasReusedInvalidEmails,
    }
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  return ret
}

export function hexToRgba(hex: any, alpha: any): string {
  let ret: string = ''
  try {
    let tempHex = hex.replace('#', '')
    if (tempHex.length === 3) {
      tempHex =
        tempHex[0] +
        tempHex[0] +
        tempHex[1] +
        tempHex[1] +
        tempHex[2] +
        tempHex[2]
    }
    if (!/^([A-Fa-f0-9]{6})$/.test(tempHex)) return ''
    const r = parseInt(tempHex.substring(0, 2), 16)
    const g = parseInt(tempHex.substring(2, 4), 16)
    const b = parseInt(tempHex.substring(4, 6), 16)
    ret = `rgba(${r}, ${g}, ${b}, ${Math.min(1.0, Math.max(0.0, alpha))})`
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  return ret
}

export function checkHasOfflineTracks(): Promise<boolean> {
  return new Promise((resolve) => {
    try {
      if (!window || !('indexedDB' in window)) {
        return resolve(false)
      }
      const request = window.indexedDB.open(
        PRACTICAL_STREAM_INDEXED_DB_NAME,
        PRACTICAL_STREAM_INDEXED_DB_VERSION,
      )
      request.onsuccess = (event: any) => {
        try {
          const db = event?.target?.result
          if (
            !db.objectStoreNames.contains(
              PRACTICAL_STREAM_INDEXED_DB_OFFLINE_MODE_SONGS_TABLE_NAME,
            )
          ) {
            return resolve(false)
          }
          const transaction = db.transaction(
            PRACTICAL_STREAM_INDEXED_DB_OFFLINE_MODE_SONGS_TABLE_NAME,
            'readonly',
          )
          const store = transaction.objectStore(
            PRACTICAL_STREAM_INDEXED_DB_OFFLINE_MODE_SONGS_TABLE_NAME,
          )
          const keyRequest = store.getAllKeys(undefined, 1)
          keyRequest.onsuccess = () => {
            resolve(keyRequest.result.length > 0)
          }
          keyRequest.onerror = () => resolve(false)
        } catch (err) {
          resolve(false)
        }
      }
      request.onerror = () => resolve(false)
    } catch (e) {
      resolve(false)
    }
  })
}

export const OFFLINE_SONGS = IS_PRODUCTION
  ? [
      {
        animation_url: `${PRACTICAL_STREAM_CDN_ADDRESS}a/pCiXwI4PbVYIHAn-d5QqHiD1GRv5na9il14tHU9j-lg.mp3`,
        token_id: '8202e1c1-211c-4437-9846-02d4df329e32',
        contract_address: '0xzzAC1643939E694DeC5D969fD48AC48D55D96321',
      },
      {
        animation_url: `${PRACTICAL_STREAM_CDN_ADDRESS}a/vaMLJzNsF2xQPSbMfjmS3NqnYJDk2SybuQ9SZZloYIw.mp3`,
        token_id: '352149b9-3978-48d3-96cf-66ba8a987b75',
        contract_address: '0xzzAC1643939E694DeC5D969fD48AC48D55D96321',
      },
      {
        animation_url: `${PRACTICAL_STREAM_CDN_ADDRESS}a/KAoNtSA-dSdCSIoH-7dskVpc30mQ-Km5xJY_P4YPhq0.mp3`,
        token_id: '37d2556b-4899-40c3-9ce1-1b02490e4172',
        contract_address: '0xzzAC1643939E694DeC5D969fD48AC48D55D96321',
      },
      {
        animation_url: `${PRACTICAL_STREAM_CDN_ADDRESS}a/UO83sJwAwg7ljtWA18YhaOZ6qOydPNdDwNtTgGGC_bE.mp3`,
        token_id: '8c9986d2-88cb-4890-bdeb-bbed4d1be6bb',
        contract_address: '0xzzAC1643939E694DeC5D969fD48AC48D55D96321',
      },
      {
        animation_url: `${PRACTICAL_STREAM_CDN_ADDRESS}a/r9rllIKY3Fw4a4EDr0HtyLLqc-m9glI7M89kuP7jUwc.mp3`,
        token_id: 'eeaf0185-1349-4b05-9c97-6b5fccebc112',
        contract_address: '0xzzAC1643939E694DeC5D969fD48AC48D55D96321',
      },
      {
        animation_url: `${PRACTICAL_STREAM_CDN_ADDRESS}a/lGk2BflU8HKVF35Q99cWZjA6iAnpZfRIX67J86Sy3Wc.mp3`,
        token_id: '8df1fb73-cf92-42d6-aebe-bfec68fcdb6b',
        contract_address: '0xzzAC1643939E694DeC5D969fD48AC48D55D96321',
      },
      {
        animation_url: `${PRACTICAL_STREAM_CDN_ADDRESS}a/Ep4MIytsf_9nexeRJPfu9xtsBASuh8IMehdkbvf2QqI.mp3`,
        token_id: '82a46d48-2945-43da-9f03-2218503db99d',
        contract_address: '0xzzAC1643939E694DeC5D969fD48AC48D55D96321',
      },
      {
        animation_url: `${PRACTICAL_STREAM_CDN_ADDRESS}a/UsakS4iqQeUS5n4psGrxArlCH3qXu3iOcKIVfzdMZEU.mp3`,
        token_id: 'f98bc652-f865-467d-ac2c-e858519e30da',
        contract_address: '0xzzAC1643939E694DeC5D969fD48AC48D55D96321',
      },
    ]
  : [
      {
        animation_url: `${ARWEAVE_GATEWAY_MAIN}jNVBQMGaZqXgoHy49rHXYw_MCHnWbD-wCCn4v6Mskls`,
        token_id:
          '100207734995273177975544027187136290572129187829540288968629664439988385742849',
        contract_address: '0x495f947276749Ce646f68AC8c248420045cb7b5e',
      },
      {
        animation_url: `${ARWEAVE_GATEWAY_MAIN}Wr85mnvVCFfY47Fr_STk8BdF8CC_V3zbEXCAGe7893E`,
        token_id:
          '100207734995273177975544027187136290572129187829540288968629664379515246215169',
        contract_address: '0x495f947276749Ce646f68AC8c248420045cb7b5e',
      },
      {
        animation_url: `${ARWEAVE_GATEWAY_MAIN}NmAxijiRU-aNxH22Ap_oRx3AyxyLSdmt_hCqBmQX_Rg`,
        token_id:
          '100207734995273177975544027187136290572129187829540288968629664414699618304001',
        contract_address: '0x495f947276749Ce646f68AC8c248420045cb7b5e',
      },
      {
        animation_url: `${ARWEAVE_GATEWAY_MAIN}9M3LTnZZZCDgplFl8mfD8Ul4Y05inBgq0D_A-5Rh1sY`,
        token_id:
          '100207734995273177975544027187136290572129187829540288968629664409202060165121',
        contract_address: '0x495f947276749Ce646f68AC8c248420045cb7b5e',
      },
      {
        animation_url: `${ARWEAVE_GATEWAY_MAIN}Tye0GbX1Dw8WM7gXlt8O3V4gcyRBamdSYNXcOVSnOh4`,
        token_id:
          '100207734995273177975544027187136290572129187829540288968629664452083013648385',
        contract_address: '0x495f947276749Ce646f68AC8c248420045cb7b5e',
      },
      {
        animation_url: `${ARWEAVE_GATEWAY_MAIN}pqv1I99rJHNYcNKacP3vY7EZz5XJKsi_ge9spV20l0c`,
        token_id:
          '100207734995273177975544027187136290572129187829540288968629664448784478765057',
        contract_address: '0x495f947276749Ce646f68AC8c248420045cb7b5e',
      },
      {
        animation_url: `${ARWEAVE_GATEWAY_MAIN}dfc33rHQat16xCQk12Hay5GACnYlVn_XZD0_34QnStc`,
        token_id:
          '100207734995273177975544027187136290572129187829540288968629664428993269465089',
        contract_address: '0x495f947276749Ce646f68AC8c248420045cb7b5e',
      },
      {
        animation_url: `${ARWEAVE_GATEWAY_MAIN}ww7hHo_c0n70zixAB4UlOQ234V08DR-SR0oeTAH0txk`,
        token_id:
          '100207734995273177975544027187136290572129187829540288968629664385012804354049',
        contract_address: '0x495f947276749Ce646f68AC8c248420045cb7b5e',
      },
      {
        animation_url: `${ARWEAVE_GATEWAY_MAIN}Y6YyYpL5AA8BDip7FcfRvSKGYYUXdwxXJk_oqhRiXC8`,
        token_id:
          '100207734995273177975544027187136290572129187829540288968629664424595222953985',
        contract_address: '0x495f947276749Ce646f68AC8c248420045cb7b5e',
      },
    ]
